export function setupProgramTooltip(){
  let tip = document.getElementById("progTooltip");
  if(!tip){
    tip = document.createElement("div");
    tip.id = "progTooltip";
    tip.innerHTML = `<div class="t"></div><div class="v"></div>`;
    document.body.appendChild(tip);
  }
  const t = tip.querySelector(".t");
  const v = tip.querySelector(".v");

  document.addEventListener("mousemove",(e)=>{
    if(tip.style.display !== "none"){
      tip.style.left = (e.clientX + 14) + "px";
      tip.style.top  = (e.clientY + 14) + "px";
    }
  });

  document.addEventListener("mouseover",(e)=>{
    const cell = e.target.closest("td.prog-cell");
    if(!cell) return;
    const full = cell.dataset.full || cell.textContent || "";
    if(t) t.textContent = "Programm";
    if(v) v.textContent = full;
    tip.style.display = "block";
  });

  document.addEventListener("mouseout",(e)=>{
    const cell = e.target.closest("td.prog-cell");
    if(!cell) return;
    tip.style.display = "none";
  });
}
